var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2168,
    cy: 19.5,
    r: 18.7832,
    fill: "#5588F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2168 28.498V26.498C27.2168 25.4372 26.7954 24.4198 26.0452 23.6696C25.2951 22.9195 24.2777 22.498 23.2168 22.498H15.2168C14.1559 22.498 13.1385 22.9195 12.3884 23.6696C11.6382 24.4198 11.2168 25.4372 11.2168 26.498V28.498",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2168 18.498C21.4259 18.498 23.2168 16.7072 23.2168 14.498C23.2168 12.2889 21.4259 10.498 19.2168 10.498C17.0077 10.498 15.2168 12.2889 15.2168 14.498C15.2168 16.7072 17.0077 18.498 19.2168 18.498Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.509fe91c86f9d1305440b696d91ef496.svg";
export { ForwardRef as ReactComponent };